export const getUsAvatarSrc = (): string => {
  return 'https://assets.urbansitter.com/static/img/logos/urbansitter-white-avatar.svg';
};

export const isProbablyHeic = (file: File): boolean =>
  file.type === 'image/heic' ||
  file.type === 'image/heif' ||
  /\.(heic|heif)$/i.test(file.name);
